import { ReactNode } from 'react';
import { Stack, StackProps } from '@mui/material';
interface Props extends StackProps {
  children: Readonly<ReactNode>;
}
const AuthContainer = ({
  children,
  sx,
  ...rest
}: Props) => {
  return <Stack sx={{
    pt: {
      xs: 'calc(56px + var(--spacing_xxl))',
      md: 'var(--spacing_xxl)'
    },
    px: {
      md: 'var(--spacing_xs)',
      xs: 'var(--spacing_m)'
    },
    gap: 'var(--spacing_m)',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px',
    mx: 'auto',
    ...sx
  }} {...rest} data-sentry-element="Stack" data-sentry-component="AuthContainer" data-sentry-source-file="AuthContainer.tsx">
      {children}
    </Stack>;
};
export default AuthContainer;